// Generated from .env.local or environment variables. Do not commit real values.
export const firebaseConfig = {
  "apiKey": "AIzaSyDSPNUxpRdSmSxhahCVztvvzU77pM6HHbQ",
  "authDomain": "solveicse.firebaseapp.com",
  "projectId": "solveicse",
  "storageBucket": "solveicse.firebasestorage.app",
  "messagingSenderId": "525206536496",
  "appId": "1:525206536496:web:b7c3054813ba6180a308f5",
  "measurementId": "",
  "databaseURL": "https://solveicse-default-rtdb.firebaseio.com"
};

export function isFirebaseConfigValid(config) {
  return !!(
    config &&
    config.apiKey &&
    config.authDomain &&
    config.projectId &&
    config.storageBucket &&
    config.messagingSenderId &&
    config.appId
  );
}

export const isFirebaseConfigured = isFirebaseConfigValid(firebaseConfig);

export default firebaseConfig;
